// @ts-nocheck
import React from "react";
import EventCard from "./EventCard";

export default function EventsList({ events, onToggleSave, isEventSaved }) {
  return (
    <div className="events-list">
      {events.map((event) => (
        <EventCard
          key={event.id}
          event={event}
          onToggleSave={onToggleSave}
          isSaved={isEventSaved(event)}
        />
      ))}
    </div>
  );
}
